import { useCheckout } from '@/context/checkout';
import Location from '../icons/Location';
import { useRouter } from 'next/router';

const BranchInfo = ({
  t,
  info,
  branchInView = null,
  setBranchInView = null,
  setFieldValue = null,
  Context = null,
}) => {
  const checkoutContext = useCheckout();
  const { pathname } = useRouter();
  const { asPath } = useRouter();
  const inBranchesPage = asPath?.includes('branches');
  const currentStoreValue = Context?.state?.currentStoreValue
  const active = currentStoreValue?.value == info?.location_id;
  
  return (
    <div
      className={`me-2 flex flex-col border
      ${
        inBranchesPage
          ? `hover:border-black/50 ${branchInView?.id == info?.id ? 'border-black/50' : ''}`
          : ''
      } 
      cursor-pointer gap-3 rounded-md border p-3 max-lg:mt-3 max-lg:min-w-60`}
      onClick={() => {
        if (!pathname?.startsWith('/checkout')) {
          setBranchInView(info);
        }
      }}
    >
      <p className='text-lg font-semibold text-red-600'>{info?.name || ''}</p>
      <div className='-mt-1 flex gap-2'>
        <Location className='mt-1' />
        <p className='line-clamp-2 min-h-12 flex-1 text-zinc-500'>
          {info?.address || ''}
        </p>
      </div>
      {!inBranchesPage && (
        <div className='flex justify-between'>
          <button
            onClick={() => {
              checkoutContext?.dispatch({ type: 'payments', payload: [] });
              checkoutContext.dispatch({
                type: 'pickup_store',
                payload: { id: info?.location_id },
              });
              Context && Context?.dispatch({type: "selectedStore", currentStoreValue: {
                label: `${info?.name} - ${info?.address}`,
                value: info?.location_id,
              }})
              setFieldValue('store_id', info?.location_id);
            }}
            className={`rounded-md bg-black px-5 py-2 lg:w-fit ${
              active ? 'border bg-white text-black' : 'bg-black text-white'
            }`}>
            {t('Show Map')}
          </button>
          <button
            onClick={() => {
              checkoutContext?.dispatch({ type: 'payments', payload: [] });
              checkoutContext.dispatch({
                type: 'pickup_store',
                payload: { id: info?.location_id },
              });
              Context && Context?.dispatch({type: "selectedStore", currentStoreValue: {
                label: `${info?.name} - ${info?.address}`,
                value: info?.location_id,
              }})
              Context && Context?.dispatch({type: "closeStorePickUp"})
              // setFieldValue('store_id', info?.location_id);
              setFieldValue(info?.location_id);
            }}
            className={`px-5 py-2 ${
              active ? 'border bg-white text-black' : 'bg-black text-white'
            } rounded-md  lg:w-fit`}
          >
            {t('Set Address')}
          </button>
        </div>
      )}
    </div>
  );
};

export default BranchInfo;
